<template>
  <div class="content"
       :style="{backgroundImage:`url(${chatBg})`,backgroundWith:'100%',}">
    <div class="inner">
      <iframe :src="urlLink"
              style="width:680px;height:610px"
              frameborder="0"></iframe>
      <!-- <div class="right">
          <p class="itemTitle">我的订单</p> -->
      <!-- <div class="itemInner">
            <el-image :src="item.image||avater"></el-image>
            <div class="itemDesc">
              <p class="title"
                 style="">{{ item.name }}</p>
              <p>{{ item.specification }}</p>
              <p class="price"> <span style="font-size:12px">
                  ￥
                </span>
                {{ item.salePrice??'' }}</p>
              <p>{{ item.factory }}</p>
            </div>
          </div> -->
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
import chatBg from "/public/img/chatBg.png"
import { getChatinfo } from "@/api/chat"
export default {
  data () {
    return {
      urlLink: '',
      chatBg: chatBg
    }
  },
  mounted () {
    this.getChatInfo()
  },
  methods: {
    getChatInfo () {
      getChatinfo().then(res => {
        if (res.code == 0) {
          this.urlLink = `https://chat.cbyyk.com?appKey=${res.data.appKey}&fromAccount=${res.data.fromAccount}&fromToken=${res.data.fromToken}`
        }

      })
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  background-color: #fff;
  height: calc(100vh - 140px);
  display: flex;
  justify-content: center;
  align-items: center;
  .inner {
    width: 728px;
    height: 658px;
    padding: 16px;
    border-radius: 4px;
    background-color: #fff;
  }
}
</style>